import { Dialog as MuiDialog, Zoom } from "@mui/material";
import { useEffect } from "react";
import {
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";

const StyledDialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== "fullScreen",
})(({ fullScreen }) => ({
  "& .MuiPaper-root": {
    minWidth: fullScreen ? "0px" : "600px",
  },
}));

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  fontWeight: theme.fontWeight[400],
  fontSize: theme.fontSize.lg,
}));

const Transition = ({ onEnter, onExited, children, in: inProp }) => {
  useEffect(() => {
    onEnter && onEnter();
    onExited && onExited();
  }, [inProp]);

  return children;
};

const Dialog = ({ title, content, open, handleClose, actions }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(
    `(max-width:${theme.breakpoints.values.sm}px)`,
  );

  return (
    <StyledDialog fullScreen={fullScreen} open={open} onClose={handleClose}>
      <StyledDialogTitle>{title}</StyledDialogTitle>
      <MuiDialogContent>{content}</MuiDialogContent>
      {actions && <MuiDialogActions>{actions}</MuiDialogActions>}
    </StyledDialog>
  );
};

export default Dialog;
